import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField as MuiTextField,
  TextField,
  Typography,
} from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import { de as deLocale } from 'date-fns/locale/de';
import styled from 'styled-components';
import { useTranslate } from '../../../locales';

const ModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40%;
  background-color: white;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 24px;
`;

const FormRow = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const BookingDetailModal = (props: any) => {
  const { bookingDetail, onClose } = props;
  const translate = useTranslate();

  return (
    <Modal
      open={!!bookingDetail}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <ModalContent>
        <IconButton
          style={{ position: 'absolute', right: 18 }}
          onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Typography variant="h5" style={{ marginBottom: 20 }}>
            {translate('admin.bookingDetail')}: {bookingDetail?.bookingHash}
          </Typography>

          <FormRow style={{ marginBottom: 20 }}>
            <DateTimePicker
              disabled
              format="DD.MM.YYYY HH:mm"
              ampm={false}
              label={translate('admin.startDateTime')}
              value={dayjs(bookingDetail?.startDate)}
              onChange={() => undefined}
            />
            <DateTimePicker
              ampm={false}
              disabled
              format="DD.MM.YYYY HH:mm"
              label={translate('admin.endDateTime')}
              value={dayjs(bookingDetail?.endDate)}
              onChange={() => undefined}
            />
          </FormRow>
          <FormRow style={{ marginBottom: 20 }}>
            <DateTimePicker
              disabled
              format="DD.MM.YYYY HH:mm"
              ampm={false}
              label={translate('admin.effectiveStartDateTime')}
              value={dayjs(bookingDetail?.effectiveStartDate)}
              onChange={() => undefined}
            />
            <DateTimePicker
              ampm={false}
              disabled
              format="DD.MM.YYYY HH:mm"
              label={translate('admin.effectiveEndDateTime')}
              value={dayjs(bookingDetail?.effectiveEndDate)}
              onChange={() => undefined}
            />
          </FormRow>

          <FormRow style={{ marginBottom: 20 }}>
            <MuiTextField
              defaultValue={bookingDetail?.user?.email}
              disabled
              style={{ width: '50%', marginRight: 20 }}
              variant="outlined"
              size="small"
              label={translate('admin.user')}
            />
          </FormRow>

          <a
            href={`/#/User/${bookingDetail?.user?.id}`}
            target="_blank"
            style={{ textDecoration: 'none' }}>
            <Button variant="contained" startIcon={<AssignmentIndIcon />}>
              {translate('admin.userDetail')}
            </Button>
          </a>
          <a
            href={`/#/Booking/${bookingDetail?.id}/show`}
            target="_blank"
            style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              style={{ float: 'right' }}>
              {translate('admin.bookingDetail')}
            </Button>
          </a>
        </LocalizationProvider>
      </ModalContent>
    </Modal>
  );
};
